export default "__VITE_ASSET__CjTAzJhL__"